(() => {
  const configElement = document.getElementById('tm-sample-variant-data');
  if (!configElement) return;
  const product = JSON.parse(configElement.textContent);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[product-samples-button]');
    if (!button) return;
    const form = button.closest('form');
    const wrapper = button.closest('.thb-product-detail');
    if (!form || !wrapper || wrapper.dataset.handle !== product.handle) return;

    const selected = new Map();
    wrapper.querySelectorAll('input[data-globoswatchindex]:checked').forEach((input) => {
      const index = Number(input.dataset.globoswatchindex.replace('option', '')) - 1;
      if (Number.isInteger(index) && index >= 0 && index < product.options.length) {
        selected.set(index, input.value);
      }
    });
    if (!selected.size) return;

    const variant = product.variants.find((item) =>
      Array.from(selected).every(([index, value]) => item.options[index] === value)
    );
    if (!variant) return;

    const input = form.querySelector('input[name="id"]');
    if (!input) return;
    input.value = String(variant.id);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);
})();
